<template>
	<header class="details-header">
		<TranslucentOverlay v-if="disabled" />
		<div class="details-header--mobile">
			<div class="segment">
				<TeamingButton
					type="TERTIARY"
					:leftIcon="['fas', 'chevron-left']"
					@buttonPress="$emit( `back` )"
				/>
			</div>
			<div class="segment">
				<h1><slot name="mobile-title"></slot></h1>
			</div>
			<div class="segment">&nbsp;</div>
		</div>
		<main class="details-header__main">
			<slot name="main"></slot>
		</main>
	</header>
</template>

<script>
import { TranslucentOverlay, TeamingButton } from "@teaming/common-ui";
export default {
	name: "DetailsHeader",
	emits: [ "back", ],
	components: {
		TeamingButton,
		TranslucentOverlay,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
$details-header-border-color: $color1-200;
$details-header-title-color: $color1-700;

.details-header {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	position: relative;
}

.details-header--mobile {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	border-bottom: 0.0625rem solid $details-header-border-color;
	padding: 1rem;

	.segment {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex: 1;
	}

	.segment:nth-child(2) {
		justify-content: center;
		flex: 2;
	}

	h1 {
		font-weight: 600;
		color: $details-header-title-color;
		@include font-and-line-for(2);
	}

	@include for-size('md') {
		display: none;
	}
}

.details-header__main {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	@include for-size('md') {
		padding: 1rem;
	}

}
</style>
